import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWhatIsYourExperienceHandlingProbateMattersInNewYorkPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-what-is-your-experience-handling-probate-matters-in-new-york/']} />;
}
